<template>
    <div id="tdMainDiv">
        <div id="tdContentDiv">
             <div id="tdFilterDiv">
                  <div style="float: right;margin-top: 8px;margin-bottom: 10px;">
                <!-- <el-button size="small" type="primary" plain v-for="(item, id) in typeOptionArr[3]" :key="id" @click="handleStatus(item)">{{ item.name }}</el-button> -->
                 <TabForSeach @handleStatus='handleStatus' tabName="筛选" :StatusArr="typeOptionArr"></TabForSeach>
            </div> 
             </div>
              
            <div id="tdTableDiv">
                <el-table
                        :data="tableData"
                        border
                        stripe
                        size="small"
                        :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
                        style="width: 100%"
                        height="100%"
                        v-loading="loading"
                >
                    <el-table-column
                            prop="typeCode"
                            align="left"
                            header-align="center"
                            :show-overflow-tooltip="true"
                             width="150"
                            label="类型编码"
                    >
                <template slot-scope="scope">
                {{ getTypeCode(scope.row.typeCode) }}
                </template>
                    </el-table-column>
                     <el-table-column
                            prop="title"
                            align="left"
                            header-align="center"
                            :show-overflow-tooltip="true"
                            width="150"
                            label="预警标题"
                    ></el-table-column>
                      <el-table-column
                            prop="content"
                            align="left"
                            header-align="center"
                            :show-overflow-tooltip="true"
                            label="预警内容"
                    ></el-table-column>
                    <!-- <el-table-column
                            prop="limitDate"
                            align="left"
                            header-align="center"
                            :show-overflow-tooltip="true"
                            width="150"
                            label="预警期限"
                    ></el-table-column> -->
                     <el-table-column
                            prop="createTime"
                            align="left"
                            header-align="center"
                            :show-overflow-tooltip="true"
                            label="生成时间"
                            width="100"
                    ></el-table-column>
                      <el-table-column
                            prop="projectName"
                            align="left"
                            header-align="center"
                            :show-overflow-tooltip="true"
                            width="150"
                            label="项目名称"
                    >
                    </el-table-column>
                     <el-table-column
                            prop="sectName"
                            align="left"
                            header-align="center"
                            :show-overflow-tooltip="true"
                            width="150"
                            label="标段名称"
                    >
                    </el-table-column>
                      <el-table-column
                            prop="personName"
                            align="left"
                            header-align="center"
                            :show-overflow-tooltip="true"
                            width="100"
                            label="接收人姓名"
                    ></el-table-column>
                    <!-- <el-table-column
                            prop="status"
                            align="center"
                            :show-overflow-tooltip="true"
                            width="80"
                            label="状态">
                        <template slot-scope="scope">
                            {{ scope.row.status === '0' ? '未读' : '已读' }}
                        </template>
                    </el-table-column> -->
                    <el-table-column fixed="right" label="操作" align="center" width="80">
                        <template slot-scope="scope">
                            <el-tooltip content="操作" placement="top">
                                <el-button
                                        v-if="scope.row.status === '0'"
                                        size="mini"
                                        type="primary"
                                        @click="handleData(scope.row)"
                                        plain
                                >未读</el-button>
                               <span  v-if="scope.row.status === '1'">已读</span>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div id="tdPaginationDiv">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[15, 30, 50, 100]"
                        :page-size="rows"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </div>
        </div>

        <!-- <div class="enptyDiaDiv">
            <el-dialog
                    closed="true"
                    closable="false"
                    :visible.sync="enptyDialogVisible"
                    @close="updateData"
                    width="0"
                    height="0"
            ></el-dialog>
        </div> -->
    </div>
</template>

<script>
import {getWarnTree,changeStatus,getWarnconfig}  from '../api/warnMessage'
import TabForSeach from '../components/TabForSeach.vue';
export default {
    components: {
	TabForSeach
	},
    name: "warnMessage",
    data() {
        return {
            loading:false,
            rows: 15,
            total: 0,
            currentPage: 1,
            tableData: [],
            keyword: '',
            dateValues: [],
            statusType: '',
            filterName: '',
            enptyDialogVisible:false,
            typeOptionArr:[],
            // statusOptions: [{
            //     value: '',
            //     label: '全部'
            // }, {
            //     value: '1',
            //     label: '未提交'
            // }, {
            //     value: '2',
            //     label: '退回'
            // }, {
            //     value: '3',
            //     label: '流转中'
            // }],
        };
    },
    methods: {
        handleStatus(val) {
            console.log(val)
            this.getTableData(val)
        },
        getTableData(filter) {
           this.loading = true
            // console.log(window.location.h)
            let prjInfo = JSON.parse(sessionStorage.getItem("projectInfo"));

            //因为计量的待办不需要这个参数，暂时注释
            var list = [];
            if(filter==-1||filter==''){
            var params = {
                page: this.currentPage,
                rows: this.rows,
                projectId: prjInfo.projectId,
                sectId:prjInfo.mainSectionId,
                // sectId:'295793845390540800',
                userFilter:0
            };
            } else {
                var params = {
                    page: this.currentPage,
                    rows: this.rows,
                    projectId: prjInfo.projectId,
                    sectId:prjInfo.mainSectionId,
                    // sectId:'295793845390540800',
                    userFilter:0,
                    typeCode:filter
                };
            }
           
            getWarnTree(params)
                .then(response => {
                    console.log(response)
                    this.loading = false
                    this.total = response.data.total;
                    if (response.data.rows != null && response.data.rows.length > 0) {
                        this.tableData = []
                        response.data.rows.map(item=>{
                            item.mainPrjName = prjInfo.mainPrjName
                            item.mainSectionName = prjInfo.mainSectionName
                        })
                        this.tableData = response.data.rows
                        this.$EventBus.$emit("getWarnMessage",this.tableData)
                    } else {
                        this.tableData = [];
                    }
                })
                .catch(error => {
                     this.loading = false
                    console.log("error:" + error.toString());
                });
        },
        handleData(data) {
            console.log(data);
            let datalist={
                id:data.id,
                status:'1'
            }
            changeStatus(datalist)
            .then(res=>{
                console.log(res)
                if(res.success){
                    this.getTableData()
                }
            })
             .catch(error => {
                    console.log("error:" + error.toString());
                });
        
        },
         handleSizeChange(val) {
      this.rows = val;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    // 获取状态值
    getConfigList(){
       getWarnconfig()
       .then(res=>{
           console.log(res,"筛选 条件")
           this.typeOptionArr = res.data.rows
       })
    },
    getTypeCode(code){
            let name = '';
            if(this.typeOptionArr && this.typeOptionArr.length){
                for(let i =0;i<this.typeOptionArr.length;i++){
                    let item = this.typeOptionArr[i];
                    if(item.code == code){ name = item.name; break; }
                }
            }
            return name;
    }
    
    },
    mounted() {
        this.getConfigList()
        this.getTableData(-1);
        
    },
    updated() {
        console.log("更新");
    },
    watch: {
        statusType(newVal) {
            this.handleCurrentChange(1)
        },
        dateValues(newVal) {
            this.handleCurrentChange(1)
        },
    }
};
</script>

<style>
    .enptyDiaDiv .el-dialog .el-dialog__headerbtn {
        visibility: hidden;
    }
    #tdMainDiv {
        height: 100%;
    }
    #tdContentDiv {
        height: 100%;
        background: white;
        padding: 0px 5px 5px 10px;
        box-sizing: border-box;
    }
    #tdFilterDiv {
        height: 45px;
        line-height: 45px;
    }
    #tdTableDiv {
        height: 100%;
        box-sizing: border-box;
        margin-top: -45px;
        padding-top: 45px;
        padding-bottom: 32px;
    }
    #tdPaginationDiv {
        height: 32px;
        background: #ecf5ff;
        text-align: left;
        margin-top: -32px;
    }
    .tdFilterTitle {
        width: 100px;
        text-align: right;
        font-size: 13px;
        margin-left: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/views/warnMessage.vue